import { render, staticRenderFns } from "./bindElevatorDialog.vue?vue&type=template&id=00124b65&scoped=true"
import script from "./bindElevatorDialog.vue?vue&type=script&lang=js"
export * from "./bindElevatorDialog.vue?vue&type=script&lang=js"
import style0 from "./bindElevatorDialog.vue?vue&type=style&index=0&id=00124b65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00124b65",
  null
  
)

export default component.exports